var _defs, _rect, _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackedBoulder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-label": "Cracked boulder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rock",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f3f3f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 18,
    fill: "#2c2c2c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 120L50 32h64l22 44-18 62H48z",
    fill: "url(#rock)",
    stroke: "#222",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22l12 36-28 28 18 24-6 26",
    fill: "none",
    stroke: "#c9b37a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24l10 30-8 24 20 26-4 26",
    fill: "none",
    stroke: "#e3d8a8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 116,
    r: 6,
    fill: "#c9b37a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 130,
    r: 7,
    fill: "#e3d8a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackedBoulder);
export default __webpack_public_path__ + "static/media/cracked-boulder.399375c0394be70b6103e535f633146c.svg";
export { ForwardRef as ReactComponent };